import React from "react";

function DsScrollingCarousel(props) {
  let carouselIntervalId;
  let g_int_currentImageId;

  document.documentElement.classList.remove("nav-open");

  React.useEffect(() => {
      // eslint-disable-next-line no-unused-vars
      let isMounted = true;

      //startCustomCarousel(bannersCount);
  
      // Cleanup function
      return () => {
        isMounted = false;
        stopCustomCarousel()
      }
    });

 /**
 * customRendering
 * @returns 
 */
 const carouselRendering = () => {
  let pictures_story_board = null;

  if (!((props.pictures_list != null) && (props.pictures_list.length > 0))){
      return (<img
        //id = "home-video"
        width="100%"
        height="100%"
        src_old="https://i.vimeocdn.com/video/1449210825-79d671233bc3780a6c12c0ec819f752bbb44b392a88dd4ff734bf58794cec5ce-d?mw=3400&mh=1913&q=70"
        src={props.fallback_picture}
    />);
  }

  pictures_story_board = props.pictures_list.map((pictureItem,ii)=>{
      return  (
                  <img id={`${props.dom_image_prefix}-${ii}`} key={pictureItem.data_guid}
                       
                      alt={pictureItem.data_blob.data_tier.partner_short_text}
                      className= {(ii==0 || props.show_all)?"custom-carousel-visible":"custom-carousel-hidden"}
                      src={pictureItem.data_blob.data_tier[props.picture_field_name]}
                      width={"100%"}
                  />)
             
          });
  
  if(props.pictures_list.length > 1 && !props.pause)
    startCustomCarousel(props.pictures_list.length);
  
  return pictures_story_board
}    

  /**
   * Prototype : startCustomCarousel
   */
  const startCustomCarousel = (p_int_carousel_images_count) => {
    if (props.debugging){
      console.log("DsScrollingCarousel::restart carousel")
    }
    // check if an interval has already been set up
    if (!carouselIntervalId) {
      carouselIntervalId = setInterval(scrollCarousel, props.pause_in_second * 1000, p_int_carousel_images_count);
      g_int_currentImageId = 0;
    }
  }

  /**
   * Prototype : stopCustomCarousel
   */
  const stopCustomCarousel = () => {
    clearInterval(carouselIntervalId);
    // release our intervalId from the variable
    carouselIntervalId = null;
  }

  async function setObjectClass(p_obj_id, p_class_name){
    let oElem = await document.getElementById(p_obj_id);
    if(oElem) oElem.className = p_class_name;
  }

  /**
   * Prototype : rotateCarousel
   * @param {*} p_bool_need_carousel_mapping 
   * @param {*} p_partners_list_fetched 
   */
  async function scrollCarousel(p_int_carousel_images_count) {
    if (props.debugging)
      console.log(`DsScrollingCarousel : p_int_carousel_images_count-> ${p_int_carousel_images_count} g_int_currentImageId->${g_int_currentImageId}`)

    var scrollingContainer = document.getElementById(props.dom_image_class_containter);
    var hasHorizontalScrollbar = scrollingContainer.scrollWidth > scrollingContainer.clientWidth;
    var hasVerticalScrollbar = scrollingContainer.scrollHeight > scrollingContainer.clientHeight;

    if (props.debugging){
      console.log("hasHorizontalScrollbar ->", hasHorizontalScrollbar)
    }

    //compute next active image ID
    g_int_currentImageId = (g_int_currentImageId + 1)%p_int_carousel_images_count;

    //Hide current image first
    //Dont show back previous one anymore setObjectClass(`${props.dom_image_prefix}-${l_int_currentImageId}`, "custom-carousel-hidden");
/*
    if (g_int_currentImageId == 0){
      if (props.debugging){
        console.clear()
        console.log("--- restarting carousel ---")
      }
      //Restore all images as l_int_nextImageId is Zero (return to First one)
      for (let ii=0; ii < p_int_carousel_images_count; ii++)
        await setObjectClass(`${props.dom_image_prefix}-${ii}`, "custom-carousel-visible");
    }
    else{
      //Hide previous image now
      await setObjectClass(`${props.dom_image_prefix}-${g_int_currentImageId-1}`, "custom-carousel-hidden");
    }
*/

    if (!hasHorizontalScrollbar || g_int_currentImageId == 0){
      g_int_currentImageId = 0
      if (props.debugging){
        console.clear()
        console.log("--- restarting carousel ---")
      }
      //Restore all images as l_int_nextImageId is Zero (return to First one)
      for (let ii=0; ii < p_int_carousel_images_count; ii++)
        await setObjectClass(`${props.dom_image_prefix}-${ii}`, "custom-carousel-visible");
    }
    else{
      //Hide previous image now
      await setObjectClass(`${props.dom_image_prefix}-${g_int_currentImageId-1}`, "custom-carousel-hidden");
    }


  }


  return (
    <div id={props.dom_image_class_containter} className={props.dom_image_class_containter}>
        {carouselRendering()}
    </div>
  );
}

export default DsScrollingCarousel;
